/* eslint-disable check-file/filename-blocklist */
export const SPACE_PERMISSIONS_UPLIFT_M1_FF = 'confluence.frontend.space-perms-uplift.milestone-1';
export const SPACE_PERMISSIONS_TABS = 'space-permissions-tabs';
